<template>
  <q-layout view="lHh Lpr lFf">
    <app-header />

    <q-page-container class="page-container" style="padding-top: 0">
      <q-page class="q-pa-md">
        <router-view />
      </q-page>
    </q-page-container>

    <confirm-modal />
    <notification-drawer />
  </q-layout>
</template>

<script setup>
import { onBeforeUnmount, onMounted } from 'vue'

import { useAuth } from 'src/composables/app/useAuth'
import { useConfirmUpdate } from 'src/composables/app/useConfirmUpdate'
import { useFcmUpdates } from 'src/composables/fcm/useFcmUpdates'
import { useFirebaseNotifications } from 'src/composables/app/useFirebaseNotifications'

import { devMode } from 'src/config'
import { storageService } from 'src/services/app/storage.service'
import { NOTIFICATION_TOPICS } from 'src/services/consts/api.const'

import AppHeader from 'src/components/layout/AppHeader.vue'
import ConfirmModal from 'src/components/common/ConfirmModal.vue'
import NotificationDrawer from 'src/components/common/NotificationDrawer.vue'

const { user, initializeFromStorage } = useAuth()
const { clearAllNotifications, loadNotificationsFromSession } = useConfirmUpdate()

useFcmUpdates()
const { subscribeToTopic } = useFirebaseNotifications()

onMounted(async () => {
  if (!user.value) await initializeFromStorage()
  if (!user.value) return
  loadNotificationsFromSession()
  setTimeout(async () => {
    devMode && (await subscribeToTopic(NOTIFICATION_TOPICS.TEST))
    subscribeToTopic(NOTIFICATION_TOPICS.USER_NOTIFICATION(user.value?.id))
  }, 1000)
})

onBeforeUnmount(async () => {
  clearAllNotifications()
  storageService.clearAllSession()
})
</script>

<style lang="scss">
@import '/src/css/setup/variables.scss';
.page-container {
  min-height: 100vh;
  max-width: $max-width-screen;
  margin: auto;
  padding-top: $header-height !important;

  .q-page {
    max-width: $max-width-screen;
  }
}
</style>
